<script>
import GeneratorMixin from "@/mixins/GeneratorMixin";
import SelectedChunks from "./SelectedChunks.vue";
import BtnGenerator from "@/components/BtnGenerator.vue";
import api from "@/api";
import CorpusMixin from "@/mixins/CorpusMixin";
// import disciplineList from "@/data/disciplines.json";

export default {
  data() {
    return {
      discipline: undefined,
      onlyDone: true,
      paPsaFilter: "psa",
      paPsaOptions: [
        {
          label: " ",
          options: [
            { value: "psa", text: "Есть ПСА" },
            { value: "only-pa", text: "Только ПА" },
          ]
        },
        {
          label: " ",
          options: [
            { value: "only-psa", text: "Только ПСА" },
            { value: "pa", text: "Есть ПА" },
            { value: "both", text: "И ПСА и ПА" }
          ]
        }
      ]
    };
  },
  mixins: [GeneratorMixin, CorpusMixin],
  props: {
    selectedChunksObject: Object,
    selectedChunks: Array,
    sections: Array,
    speciality: Object
  },
  components: { BtnGenerator, SelectedChunks },
  emits: ["unselect-excluded", "on-ok"],

  methods: {
    ok() {
      const chunkList = this.selectedChunks.map(x => x.id);
      const data = { chunkList, discipline: this.discipline, onlyDone: this.onlyDone };
      if (this.forPa !== null) {
        data.forPa = this.forPa;
      }
      if (this.forPsa !== null) {
        data.forPsa = this.forPsa;
      }
      api({
        url: `/corpus/${this.corpusId}/chunk/exportWord`,
        method: "post",
        responseType: "blob",
        data
      }).then(() => {
        this.$bvToast.toast("Выгрузка запланирована", { ...this.commonToaster, variant: "success" });
        this.$emit("on-ok");
        this.$bvModal.hide("modal-export-word");
      });
    }
  },
  computed: {
    forPa() {
      if (this.paPsaFilter === "psa") {
        return null;
      }
      return this.paPsaFilter !== "only-psa";
    },
    forPsa() {
      if (this.paPsaFilter === "pa") {
        return null;
      }
      return this.paPsaFilter !== "only-pa";
    }
    // disciplineList() {
    //   return disciplineList[this.speciality.code];
    // }
  }
};
</script>

<template>
  <b-modal
    id="modal-export-word"
    centered
    lazy
    ok-title="Выгрузить"
    scrollable
    size="lg"
    static
    title="Выгрузка шаблона Word"
  >
    <selected-chunks :sections="sections" :selected-chunks="selectedChunksObject" />

    <template #modal-footer>
      <b-checkbox v-model="onlyDone">
        Только проверенные
      </b-checkbox>
      <b-form-select v-model="paPsaFilter" :options="paPsaOptions" class="pa-psa-select" />
      <b-btn variant="outline-secondary" @click="$emit('unselect-excluded')">
        Исключить исключенные
      </b-btn>
      <b-button variant="primary" @click="ok()">
        Выгрузить
      </b-button>
    </template>
  </b-modal>
</template>

<style>
#modal-generate-headings .modal-content {
  min-height: 300px;
}

#modal-export-word .pa-psa-select {
  max-width: 220px;
}
</style>